import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import AppHeader from '../../components/navBar/AppHeader';
import { HeaderSlotProvider } from '../../components/navBar/HeaderSlotContext';
import MWXNavBar from '../../components/navBar/MWXNavBar';
import { FEATURE_FLAGS, useFeatureFlag } from '../../lib/featureFlags';

export const Route = createFileRoute('/_authenticated/_navbar')({
  component: NavbarLayout,
});

function NavbarLayout() {
  const compactHeader = useFeatureFlag(FEATURE_FLAGS.compactHeader);

  if (compactHeader) {
    return (
      <HeaderSlotProvider>
        <AppHeader />
        <Outlet />
      </HeaderSlotProvider>
    );
  }

  return (
    <Box>
      <MWXNavBar />
      <Outlet />
    </Box>
  );
}
